/*
 * 验证输入内容： 
 * isPhoneNumber： 手机号
 * isUserPassword： 密码
 * isEmpty： 输入内容：为空返回真
 * isNickName: 昵称
 * isRealName：真实姓名
 */
const regex = {
  //判断邮箱
  isEmail: function name(email) {
    let reg = /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/;
    let isEmail = reg.test(email);

    return isEmail;
  },
  isPhoneNumber: function (phoneNum) {
    // let reg = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
    let reg = /^(1)\d{10}$/;
    let isPhoneNum = reg.test(phoneNum);

    return isPhoneNum;
  },
  isUserPassword: function (pwd) {
    let reg = /^([a-zA-Z0-9!@#$%^&*]{6,16})$/i;
    let isPwd = reg.test(pwd);

    return isPwd;
  },
  isAuthCode: function (code) {
    let reg = /\d{4}/;
    let isCode = reg.test(code);

    return isCode;
  },
  isPayPassword: function (password) {
    let reg = /^\d{6}$/i;
    let isPassword = reg.test(password);

    return isPassword;
  },
  // 判断为空
  isEmpty: function (iptCon) {
    let iptContent = false;
    let con = iptCon + '';

    if (con == "" || !con.replace(/(^\s*)|(\s*$)/g, "")) {
      iptContent = true;
    }

    return iptContent;
  },
  // 判断昵称
  isNickName: function (name) {
    let reg = /^[^-_\~!@#\$%\^&\*\.\(\)\[\]\{\}<>\?\\\/\'\"]{2,10}$/;
    let isName = reg.test(name);

    return isName;
  },
  // 判断姓名
  isRealName: function (realName) {
    let reg = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/;
    let isRName = reg.test(realName);

    return isRName;
  },
  isTrueResult: function (arr) {
    let arrStatus = true;

    if (arr == false || arr === 'false' || arr === 'FALSE' || arr == 0 || arr === '0') {
      arrStatus = false;
    }

    return arrStatus;
  },
  // 检查字符长度是否为6位
  checkStringLength: function (str) {
    let isTrue = true;

    if (str.trim().length < 6) {
      isTrue = false;
    }

    return isTrue;
  },
  // 判断是否是内链
  isInsideNetwork: function (arr, url) {
    if (typeof (arr) === 'string') {
      return RegExp(arr).test(url);
    } else {
      for (var i = 0; i < arr.length; i++) {
        if (RegExp(arr[i]).test(url)) {
          return true;
        }
      }
    }
    return false;
  },
    /**
    根据身份证号码判断性别
    15位身份证号码：第7、8位为出生年份(两位数)，第9、10位为出生月份，第11、12位代表出生日
    18位身份证号码：第7、8、9、10位为出生年份(四位数)，第11、第12位为出生月份，
    第13、14位代表出生日期，第17位代表性别，奇数为男，偶数为女。
  */
  //根据身份证号获取年龄
  GetAge: function (identityCard) {
    var len = (identityCard + "").length;
    var strBirthday = "";
    if (len == 18)//处理18位的身份证号码从号码中得到生日和性别代码
    {
      strBirthday = identityCard.substr(6, 4) + "/" + identityCard.substr(10, 2) + "/" + identityCard.substr(12, 2);
    }
    if (len == 15) {
      var birthdayValue = '';
      birthdayValue = identityCard.charAt(6) + identityCard.charAt(7);
      if (parseInt(birthdayValue) < 10) {
        strBirthday = "20" + identityCard.substr(6, 2) + "/" + identityCard.substr(8, 2) + "/" + identityCard.substr(10, 2);
      } else {
        strBirthday = "19" + identityCard.substr(6, 2) + "/" + identityCard.substr(8, 2) + "/" + identityCard.substr(10, 2);
      }

    }
    //时间字符串里，必须是“/”
    var birthDate = new Date(strBirthday);
    var nowDateTime = new Date();
    var age = nowDateTime.getFullYear() - birthDate.getFullYear();
    //再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
    if (nowDateTime.getMonth() < birthDate.getMonth() || (nowDateTime.getMonth() == birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  },
  getSex (idCard){
    var sexStr = "";
    if (parseInt(idCard.slice(-2, -1)) % 2 == 1) {
      sexStr = "m";
    } else {
      sexStr = "w";
    }
    return sexStr;
  },
  isCardN: function (identityCard) {
    //身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
    var reg = /(^\d{15}$)|(^\d{17}(\d|X|x)$)/;

    if (reg.test(identityCard) === false) {
      return false;
    }

    return true;
  },
  isIDNumber(idNumber) {
    var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  
    if (reg.test(idNumber) === false) {
      return false;
    }
  
    return true;
  }

}

export default regex


// WEBPACK FOOTER //
// ./src/filter/regex.js